import React, { useEffect } from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import topImage from '../../assets/images/splash-top.png';
import logoImage from '../../assets/images/splash-logo.png';
import footerImage from '../../assets/images/splash-footer.png';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useHistory } from "react-router-dom";

const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "IRANYekan",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

const Splash = () => {
  let history = useHistory();
  useEffect(() => {
    const timer = setTimeout(() => {
      history.replace('/login');
    }, 4000);
    return () => {
      clearTimeout(timer);
    }
  }, [history]);
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            width: '100%',
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <img alt="Japanese Technology" src={topImage} width="150" />
          <img alt="Japanese Technology" src={logoImage} width='250' />
          <img alt="Japanese Technology" src={footerImage} width='250' />
        </Box>
      </Grid>
    </ThemeProvider>
  );
};

export default Splash;
